/************************************
1. If you want to add or remove items you will need to change a variable called $slide-count in the CSS *minimum 3 slides

2. if you want to change the dimensions of the slides you will need to edit the slideWidth variable here 👇 and the $slide-width variable in the CSS.
************************************/
import React from "react";
// import { Link } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const options = {
  responsive: {
    0: {
      items: 1,
    },
    400: {
      items: 1,
    },
    600: {
      items: 2,
    },
    700: {
      items: 2,
    },
    1000: {
      items: 3.5,
    },
  },
};

const Roadmap = () => {
  return (
    <>
      <div className="roadmap_section mob-roadmapsection">
        <h2
          className="head_pt main_banner-heading"
          style={{ textAlign: "left", paddingLeft: "0" }}
        >
          Roadmap
        </h2>
        {/* <!-- live auctions --> */}
        <section className="inner">
          {/* <!-- title --> */}
          {/* <div className="col-12">
            <div className="main__title">
              <h2><a href="#">Latest Chords</a></h2>
            </div>
          </div> */}
          {/* <!-- end title --> */}

          {/* carousel  */}
          <div className="col-12">
            <OwlCarousel
              className="owl-theme hero chords"
              loop
              margin={10}
              nav
              id="hero"
              autoheight="true"
              {...options}
              style={{ marginTop: "0", padding: "28px 0px 0px 0px" }}
            >
              <div className="item roadmap_card">
                <div className="row roadmap_title">
                  <div className="col-xl-2 col-lg-2 col-md-2 col-sm-1 col-xs-3">
                    <span>1:</span>
                  </div>
                  <div
                    className="col-xl-8 col-lg-8 col-md-10 col-sm-11 col-xs-9 right_road"
                    style={{ margin: "auto 0" }}
                  >
                    <p>
                      Welcome to the <br />
                      Billionaires
                    </p>
                  </div>
                </div>
                <div className="row roadmap_content">
                  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <p className="para__1">
                      As soon as our artists have performed their magic and our{" "}
                      <b>Little Billionaires</b> have unfolded their full glory,
                      our journey begins. The <b>Little Billionaires </b>open
                      their gates to you. Our community is growing and we are
                      giving away 20 whitelisting spots to our most active
                      community members.
                    </p>
                    <p className="para__new">
                      As you can see, we pay close attention to detail and have
                      focused on providing the greatest possible value to our
                      community. In the mean time, get together, chat, engage
                      and interact.
                    </p>
                  </div>
                </div>
              </div>
              <div className="item roadmap_card">
                <div className="row roadmap_title">
                  <div className="col-xl-2 col-lg-2 col-md-2 col-sm-1 col-xs-3">
                    <span>2:</span>
                  </div>
                  <div
                    className="col-xl-8 col-lg-8 col-md-10 col-sm-11 col-xs-9 right_road"
                    style={{ margin: "auto 0" }}
                  >
                    <p>
                      Website and
                      <br /> Mint Start{" "}
                    </p>
                  </div>
                </div>
                <div className="row roadmap_content">
                  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <p className="para__2">
                      Let the minting begin, our website welcomes you. <br />
                      <b>7,777 </b>unique <b>Little Billionaires</b> are ready
                      to change hands and serve your benefit.
                    </p>
                  </div>
                </div>
              </div>
              <div className="item roadmap_card">
                <div className="row roadmap_title">
                  <div className="col-xl-2 col-lg-2 col-md-2 col-sm-1 col-xs-3">
                    <span>3:</span>
                  </div>
                  <div
                    className="col-xl-8 col-lg-8 col-md-10 col-sm-11 col-xs-9 right_road"
                    style={{ margin: "auto 0" }}
                  >
                    <p className="line_para">Reveal </p>
                  </div>
                </div>
                <div className="row roadmap_content">
                  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <p className="para__3">
                      Your <b>Little Billionaires</b> will be revealed{" "}
                      <b>72 hours</b> after the mint and are already on their
                      way to making use of our unique staking program to get
                      rewarded in <b>$LITTLE</b> tokens
                    </p>
                  </div>
                </div>
              </div>
              <div className="item roadmap_card">
                <div className="row roadmap_title">
                  <div className="col-xl-2 col-lg-2 col-md-2 col-sm-1 col-xs-3">
                    <span>4:</span>
                  </div>
                  <div
                    className="col-xl-8 col-lg-8 col-md-10 col-sm-11 col-xs-9 right_road"
                    style={{ margin: "auto 0" }}
                  >
                    <p className="line_para">
                      Lock your <br />
                      NFTs
                    </p>
                  </div>
                </div>
                <div className="row roadmap_content">
                  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <p className="para__4">
                      Our staking program will be available to every NFT holder
                      immediately after the reveal. By simply holding your{" "}
                      <b>Little Billionaire </b>in our staking, you will receive
                      daily profits in <b>$LITTLE</b> tokens which you can hold
                      or convert into other currencies.
                    </p>
                  </div>
                </div>
              </div>
              <div className="item roadmap_card">
                <div className="row roadmap_title">
                  <div className="col-xl-2 col-lg-2 col-md-2 col-sm-1 col-xs-3">
                    <span>5:</span>
                  </div>
                  <div
                    className="col-xl-8 col-lg-8 col-md-10 col-sm-11 col-xs-9 right_road"
                    style={{ margin: "auto 0" }}
                  >
                    <p className="line_para">Get Rewarded</p>
                  </div>
                </div>
                <div className="row roadmap_content">
                  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <p className="para__5">
                      Hold your <b>$LITTLE</b> Token in your user panel and get
                      rewarded with MATIC just by holding them. Get ready for
                      our IPCO where the <b>$LITTLE</b> price will be four times
                      as high.
                    </p>
                  </div>
                </div>
              </div>
              <div className="item roadmap_card">
                <div className="row roadmap_title">
                  <div className="col-xl-2 col-lg-2 col-md-2 col-sm-1 col-xs-3">
                    <span>6:</span>
                  </div>
                  <div
                    className="col-xl-8 col-lg-8 col-md-10 col-sm-11 col-xs-9 right_road"
                    style={{ margin: "auto 0" }}
                  >
                    <p>
                      New exchange <br />
                      possibilities
                    </p>
                  </div>
                </div>
                <div className="row roadmap_content">
                  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <p className="para__6">
                      We are providing new ways to exchange your <b>$LITTLE</b>{" "}
                      tokens into other currencies directly after receiving them
                      as a staking reward. MATIC will be there from the start
                      for everyone who prefers MATIC. Other exchange options are
                      going to be available and preserve new staking
                      opportunities for the community through transaction fees.
                    </p>
                  </div>
                </div>
              </div>
              <div className="item roadmap_card">
                <div className="row roadmap_title">
                  <div className="col-xl-2 col-lg-2 col-md-2 col-sm-1 col-xs-3">
                    <span>7:</span>
                  </div>
                  <div
                    className="col-xl-8 col-lg-8 col-md-10 col-sm-11 col-xs-9 right_road"
                    style={{ margin: "auto 0" }}
                  >
                    <p className="line_para">$LITTLE IPO</p>
                  </div>
                </div>
                <div className="row roadmap_content">
                  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <p className="para__7">
                      <b>$LITTLE</b> token IPO kicks off, providing early access
                      for all NFT holders. Transaction fees lead to further
                      staking profits for NFT holders. We will have 2 major
                      phases. Prices are going to be announced. Little heads up:
                      Phase 2 price will be 0.20 USD per <b>$LITTLE.</b>
                    </p>
                  </div>
                </div>
              </div>
              <div className="item roadmap_card">
                <div className="row roadmap_title">
                  <div className="col-xl-2 col-lg-2 col-md-2 col-sm-1 col-xs-3">
                    <span>8:</span>
                  </div>
                  <div
                    className="col-xl-8 col-lg-8 col-md-10 col-sm-11 col-xs-9 right_road"
                    style={{ margin: "auto 0" }}
                  >
                    <p>
                      TIER A Stock Exchange <br />
                      Listing Q2 2022
                    </p>
                  </div>
                </div>
                <div className="row roadmap_content">
                  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <p className="para__8">
                      $LITTLE Token is listed on multiple exchanges. Among
                      others, one TIER A Exchange will list $LITTLE. More
                      Exchanges TBA.
                    </p>
                  </div>
                </div>
              </div>
              <div className="item roadmap_card">
                <div className="row roadmap_title">
                  <div className="col-xl-2 col-lg-2 col-md-2 col-sm-1 col-xs-3">
                    <span>9:</span>
                  </div>
                  <div
                    className="col-xl-8 col-lg-8 col-md-10 col-sm-11 col-xs-9 right_road"
                    style={{ margin: "auto 0" }}
                  >
                    <p className="line_para">
                      Little Billionaires <br />
                      Wives{" "}
                    </p>
                  </div>
                </div>
                <div className="row roadmap_content">
                  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <p className="para__9">
                      Upcoming NFT Collection with more utilities for holders.
                      Benefit from exclusive whitelist options as{" "}
                      <b>Little Billionaire</b> holder.
                    </p>
                  </div>
                </div>
              </div>
              <div className="item roadmap_card">
                <div className="row roadmap_title">
                  <div className="col-xl-2 col-lg-2 col-md-2 col-sm-1 col-xs-3">
                    <span>10:</span>
                  </div>
                  <div
                    className="col-xl-8 col-lg-8 col-md-10 col-sm-9 col-xs-9 right_road"
                    style={{ margin: "auto 0" }}
                  >
                    <p style={{ marginLeft: "18px" }}>
                      NFT Marketplace <br />
                      Beta Phase{" "}
                    </p>
                  </div>
                </div>
                <div className="row roadmap_content">
                  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-11 col-xs-12">
                    <p className="para__10">
                      We are launching the Beta Phase of our NFT Marketplace
                      where $LITTLE will be the major means of payment.
                    </p>
                  </div>
                </div>
              </div>
            </OwlCarousel>
          </div>
          {/* end carousel  */}
        </section>
        {/* end live auctions */}
      </div>
    </>
  );
};

export default Roadmap;
